<template>
  <div class="exam-status-bar">
    <div class="exam-status-bar-header">
      <div class="exam-status-bar-header-event">
        {{ lastEventLabel }}

        <template
          v-if="
            [
              TraceabilityStatus.InTransit,
              TraceabilityStatus.InTransitBetweenNTOs
            ].includes(lastEvent.status)
          "
        >
          <button
            type="button"
            class="exam-status-bar-header-event-button"
            @click.stop="handleOpenPath"
          >
            Ver trajeto

            <svg-loader
              src="/static/images/icon-map-marker.svg"
            />
          </button>

          <view-batch-route-modal
            ref="viewBatchRouteModal"
            :exam="exam"
          />
        </template>
      </div>

      <div class="exam-status-bar-header-date">
        {{ lastEventDate | date }}
      </div>
    </div>

    <div class="exam-status-bar-progress-bar">
      <div
        class="exam-status-bar-progress-bar-progress"
        :style="{
          width: `${progress}%`,
          backgroundColor: traceabilityStatusColors[lastEvent.status]
        }"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment'

import { TraceabilityStatus } from '@/enums';

import { traceabilityStatusLabels, traceabilityStatusColors } from '@/constants';

import ViewBatchRouteModal from './ViewBatchRouteModal'

export default {
  name: 'ExamStatusBar',
  components: {
    ViewBatchRouteModal
  },
  filters: {
    date(date) {
      return moment(date).format('DD/MM/YYYY [às] HH:mm')
    }
  },
  props: {
    events: {
      type: Array,
      required: true
    },
    dueDate: {
      type: String,
      required: true
    },
    exam: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      TraceabilityStatus,
      traceabilityStatusLabels,
      traceabilityStatusColors
    }
  },
  computed: {
    progress() {
      const registeredEvent = this.events.find(event => event.status === TraceabilityStatus.Registered)

      if (registeredEvent) {
        const registeredDate = moment(registeredEvent.date)
        const dueDate = moment(this.dueDate)
        const totalDays = dueDate.diff(registeredDate, "days")
        const currentDate = moment()
        const passedDays = currentDate.diff(registeredDate, "days")
        const progress = (passedDays * 100) / totalDays

        return progress > 100 ? 100 : progress
      }

      return 0
    },
    orderedEvents() {
      return [...this.events].sort((a, b) => moment(b.date).diff(moment(a.date)));
    },
    lastEvent() {
      return this.orderedEvents[0]
    },
    lastEventDate() {
      return moment(this.lastEvent.date)
    },
    lastEventLabel() {
      return traceabilityStatusLabels[this.lastEvent.status]
    }
  },
  methods: {
    handleOpenPath() {
      this.$refs.viewBatchRouteModal.open()
    }
  }
}
</script>

<style lang="scss" scoped>
@use "@/../static/stylesheets/variables" as *;

.exam-status-bar {
  font-family: 'Exo 2';
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  &-header {
    display: flex;
    gap: 1rem;
    justify-content: space-between;
    font-size: 0.875rem;

    &-event {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-weight: 600;
      color: #363636;

      &-button {
        height: auto;
        font-size: 0.75rem;
        font-weight: normal;
        border: initial;
        transition: none;
        animation-duration: initial;
        color: $brand-primary;
        border-radius: 0;
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;
        background-color: transparent;
        padding: 0;
        margin: 0;

        .md-icon {
          width: 0.875rem;
          height: 0.875rem;
          min-width: auto;
          min-height: auto;
        }
      }
    }

    &-date {
      font-weight: 400;
      color: #595959;
    }
  }

  &-progress-bar {
    width: 100%;
    height: 0.5rem;
    border-radius: 0.375rem;
    padding: 0.0625rem;
    background-color: #E6E6E6;

    &-progress {
      height: 0.5rem;
      border-radius: 0.375rem;
    }
  }
}
</style>
